
import { Helmet } from "react-helmet";

const HebrewTermsPage = () => {
  return (
    <div className="container mx-auto px-4 py-8" dir="rtl">
      <Helmet>
        <title>תנאי השירות - Lainasampo.fi</title>
        <meta name="description" content="תנאי השירות של שירות השוואת הלוואות Lainasampo.fi" />
      </Helmet>
      
      <div className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-sm">
        <h1 className="text-3xl font-bold text-blue-800 mb-6">תנאי השירות</h1>

        <div className="prose prose-blue max-w-none">
          <p className="text-sm text-gray-500 mb-4">
            זהו תרגום של תנאי השירות שלנו בפינית. הגרסה הפינית היא הגרסה המחייבת מבחינה משפטית.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">1. תיאור השירות</h2>
          <p className="mb-4">
            Lainasampo.fi הוא שירות השוואת הלוואות ובקשות הלוואה המעביר בקשות הלוואה לשותפיו. 
            Lainasampo.fi אינו מעניק הלוואות בעצמו, אלא משמש כמתווך בין לקוחות ומוסדות פיננסיים.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">2. שימוש בשירות</h2>
          <p className="mb-4">בעת שימוש בשירות שלנו, עליך:</p>
          <ul className="list-disc pr-6 mb-4 space-y-2">
            <li>לספק מידע נכון ועדכני בבקשת ההלוואה שלך</li>
            <li>להיות לפחות בן 18 וכשיר משפטית</li>
            <li>להשתמש בשירות רק למטרות חוקיות</li>
            <li>לציית לחוק הפיני ולתנאי שירות אלה</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">3. בקשות הלוואה</h2>
          <p className="mb-4">על ידי הגשת בקשת הלוואה באמצעות Lainasampo.fi:</p>
          <ul className="list-disc pr-6 mb-4 space-y-2">
            <li>אתה מסמיך אותנו להעביר את בקשתך לשותפינו</li>
            <li>אתה מקבל ששותפינו עשויים לבדוק את פרטי האשראי שלך</li>
            <li>אתה מבין שההחלטה הסופית על ההלוואה מתקבלת על ידי המוסד הפיננסי, ולא על ידי Lainasampo.fi</li>
            <li>אתה מקבל שאנחנו עשויים ליצור איתך קשר בנוגע לבקשת ההלוואה שלך</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">4. הצעות הלוואה</h2>
          <p className="mb-4">
            הצעות ההלוואה נעשות על ידי שותפינו. איננו יכולים להבטיח שתקבל הצעות הלוואה או שההצעות 
            יענו על ציפיותיך. התנאים של ההצעות שתקבל תלויים במספר גורמים, כמו פרטי האשראי שלך, 
            הכנסתך ומדיניות ההלוואה של המוסדות הפיננסיים.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">5. ללא תשלום</h2>
          <p className="mb-4">
            שירותי Lainasampo.fi ניתנים ללא תשלום ללקוחות. אנו מממנים את פעילותנו באמצעות עמלות 
            המשולמות על ידי שותפינו.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">6. הגבלות אחריות</h2>
          <p className="mb-4">Lainasampo.fi אינה אחראית עבור:</p>
          <ul className="list-disc pr-6 mb-4 space-y-2">
            <li>החלטות הלוואה שנעשות על ידי שותפים או תנאי ההצעות שלהם</li>
            <li>החזר הלוואה או יחסים בין הלווה למלווה</li>
            <li>נזקים עקיפים או תוצאתיים שעלולים לנבוע משימוש בשירות</li>
            <li>הפסקות שירות זמניות או בעיות טכניות</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">7. זכויות קניין רוחני</h2>
          <p className="mb-4">
            כל התוכן ב-Lainasampo.fi, כולל טקסטים, תמונות, לוגואים, תוכניות מחשב וחומר אחר, 
            מוגן בזכויות קניין רוחני ושייך ל-Lainasampo Oy או למעניקי הרישיון שלה. העתקה, 
            הפצה או שימוש אחר בתוכן ללא רשות אסורה.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">8. תקשורת</h2>
          <p className="mb-4">
            על ידי שימוש בשירות שלנו, אתה מקבל שאנו עשויים לשלוח לך מידע על השירות שלנו, בקשת ההלוואה שלך 
            והצעות הלוואה באמצעות דוא"ל או אמצעים אלקטרוניים אחרים. אתה רשאי בכל עת לבטל את הסכמתך לתקשורת 
            שיווקית על ידי יצירת קשר עם שירות הלקוחות שלנו.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">9. שינויים בתנאים</h2>
          <p className="mb-4">
            אנו שומרים לעצמנו את הזכות לשנות את תנאי השירות הללו. אנו נפרסם את התנאים המתוקנים באתר שלנו 
            והם יכנסו לתוקף מיד. המשך השימוש באתר לאחר השינויים בתנאים ייחשב כקבלה של התנאים החדשים.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">10. חוק החל ויישוב סכסוכים</h2>
          <p className="mb-4">
            תנאי שירות אלה כפופים לחוק הפיני. כל סכסוך ייפתר בראש ובראשונה באמצעות משא ומתן. אם לא ניתן 
            להגיע להסכמה, הסכסוכים יפתרו בבית המשפט המחוזי של הלסינקי.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">11. פרטי קשר</h2>
          <p className="mb-4">אם יש לך שאלות על תנאי השירות, אנא צור קשר עם:</p>
          <p>
            Lainasampo Oy<br />
            דוא"ל: asiakaspalvelu@lainasampo.fi
          </p>
        </div>
      </div>

      <p className="text-sm text-gray-500 text-center mt-8 mb-8">תנאים אלה עודכנו לאחרונה בתאריך: 1 ביוני 2023</p>
    </div>
  );
};

export default HebrewTermsPage;
